import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { RegistroObservacionesDocumentosDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class RegistroObservacionesDocumentosService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getRegistroObservacionesDocumentosService(): Observable<BodyListResponse<RegistroObservacionesDocumentosDTO>> {
    return this.http.get<BodyListResponse<RegistroObservacionesDocumentosDTO>>(API_URL + '/api/v1/registroObservacionesDocumentos/todos');
  }

  guardarRegistroObservacionesDocumentosService(registroObservacionesDocumentosDTO: RegistroObservacionesDocumentosDTO): Observable<BodyResponse<RegistroObservacionesDocumentosDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/registroObservacionesDocumentos', registroObservacionesDocumentosDTO);
  }

  getRegistroObservacionesDocumentosPorCodigoService(codigo: string): Observable<BodyResponse<RegistroObservacionesDocumentosDTO>> {
    return this.http.get<BodyResponse<RegistroObservacionesDocumentosDTO>>(API_URL + '/api/v1/registroObservacionesDocumentos/' + codigo);
  }

  getRegistroObservacionesDocumentosParticipanteService(codigoParticipante: string, orden: String): Observable<BodyListResponse<RegistroObservacionesDocumentosDTO>> {
    return this.http.get<BodyListResponse<RegistroObservacionesDocumentosDTO>>(API_URL + '/api/v1/registroObservacionesDocumentos/participante/' + codigoParticipante + '/' + orden);
  }
}
